export default __webpack_public_path__ + "static/media/blog-2.2f8de5b9.jpg";